export default __webpack_public_path__ + "static/media/add-b.40c30c91.svg";